import { Country_Enum } from "@/graphql";

/**
 * Whether a calculation type's flat `threshold` must NOT stand in when no per-building-type row matches.
 *
 * `getThresholds` normally falls back to the type's own `threshold` when it finds no
 * `thresholdByBuildingType` row. Denmark's BR18 (2025) is the exception: it carries no flat threshold at
 * all (18 rows instead), so a fallback there would be silently substituting a null, and an unmatched
 * building type has to read as "no limit value yet" rather than as a number.
 *
 * Extracted because two places now decide the same thing: the Calculation prerequisites step, which
 * resolves the limit value on mount, and the start-project dialog, which shows it before the wizard opens.
 * Two copies of a rule that governs a displayed number and a stored one drift, and the failure mode is a
 * dialog promising a limit value the step then contradicts.
 *
 * Takes the country in either spelling. The step holds the address's long name ("Denmark"), the dialog
 * holds the enum ("DENMARK"), and uppercasing makes both land on the same comparison.
 */
export const suppressThresholdFallback = (
  country: string | null | undefined,
  calculationTypeLabel: string | null | undefined
): boolean => country?.toUpperCase() === Country_Enum.DENMARK && calculationTypeLabel === "BR18 (2025)";
